class RouteAds {
  constructor({ wait }) {
    this.wait = wait
  }
}

export default RouteAds
